import React from 'react';
import { StaffMembersDataHooks } from './dataHooks';
import { TagName } from '../../../../utils/tagName.const';
import { ServiceType, StaffMember } from '@wix/bookings-uou-types';
import Text, { TextType } from '../../Text/Text';
import { TFunction, useTranslation } from '@wix/yoshi-flow-editor';
import { Service } from '../../../../utils/mappers/service.mapper';

export interface StaffMembersProps {
  service: Service;
}

const StaffMembers: React.FC<StaffMembersProps> = ({ service }) => {
  const { t } = useTranslation();
  const staffMemberNames = getStaffMembers(service, t);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={StaffMembersDataHooks.STAFF_MEMBER}
      tagName={TagName.Paragraph}
    >
      {staffMemberNames}
    </Text>
  );
};

const getStaffMembers = (service: Service, t: TFunction) => {
  const staffMembers: StaffMember[] = service.staffMembers || [];
  if (staffMembers.length || service.type !== ServiceType.INDIVIDUAL) {
    return staffMembers.map((staffMember) => staffMember.name).join(', ');
  }
  return t('app.bookings-form.appointment-details.first-available');
};

export default StaffMembers;
